"use client";

export function Grid() {
    return (
        <div className="h-full w-full bg-[linear-gradient(to_right,#ffffff1C_1px,transparent_1px),linear-gradient(to_bottom,#ffffff1C_1px,transparent_1px)] bg-[size:12px_12px]">
            <div className="h-full w-full bg-black [mask-image:radial-gradient(ellipse_at_center,transparent_1%,black)]" />
        </div>
    );
}
